import { render, staticRenderFns } from "./TagReadonly.vue?vue&type=template&id=b3fbc506"
import script from "./TagReadonly.vue?vue&type=script&lang=js"
export * from "./TagReadonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports